
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { PhotoFormFields } from "../photo-shared/PhotoFormFields";

interface PhotoEditFormProps {
  form: UseFormReturn<any>;
  isAdmin?: boolean;
  disabled?: boolean;
  onCopyFromCaption: () => void;
  previewImageSrc?: string | null;
  showPositioningSection?: boolean;
  permissionNote?: string;
}

export const PhotoEditForm: React.FC<PhotoEditFormProps> = ({
  form,
  isAdmin,
  disabled,
  onCopyFromCaption,
  previewImageSrc,
  showPositioningSection = true,
  permissionNote,
}) => {
  // Get yOffset from form state or default to 0
  const yOffset = form.watch('yOffset') ?? 0;
  
  const handleYOffsetChange = (value: number) => {
    form.setValue('yOffset', value);
  };

  return (
    <PhotoFormFields
      form={form}
      isAdmin={isAdmin}
      disabled={disabled}
      onCopyFromCaption={onCopyFromCaption}
      previewImageSrc={previewImageSrc}
      showPositioningSection={showPositioningSection}
      onYOffsetChange={handleYOffsetChange}
      permissionNote={permissionNote}
    />
  );
};
